// routes/AuthRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout';
import Login from '../components/Login/Login';
import ForgotPassword from '../components/Login/ForgotPassword';
import ResetPassword from '../components/Login/ResetPassword';
import Otp from '../components/Login/Otp';
import Signout from '../components/Signout/Signout';
import VerifyThirdPartyLogin from '../components/Login/VerifyThirdPartyLogin';

export const authRoutes = (
  <>
    <Route path="/" element={<AuthLayout><Login /></AuthLayout>} />
    <Route path="/login" element={<AuthLayout><Login /></AuthLayout>} />
    <Route path="/forgotpassword" element={<AuthLayout><ForgotPassword /></AuthLayout>} />
    <Route path="/resetpassword/:userkey" element={<AuthLayout><ResetPassword /></AuthLayout>} />
    <Route path="/resetpassword/" element={<AuthLayout><ResetPassword /></AuthLayout>} />
    <Route path="/otp" element={<AuthLayout><Otp /></AuthLayout>} />
    <Route path="/signout" element={<Signout />} />
    <Route path="/verify_third_party_login" element={<AuthLayout><VerifyThirdPartyLogin /></AuthLayout>} />
  </>
);
